import React from "react";
import { InputGroup, Form } from "react-bootstrap";

interface VerBusinessDetailsProps {
  label: string;
  defaultValue: any;
  disabled?: boolean;
  colored?: boolean;
  required?: boolean;
}

const VerBusinessDetails: React.FC<VerBusinessDetailsProps> = ({
  label,
  defaultValue,
  disabled = true,
  colored = false,
  required = false,
}) => {
  return (
    <InputGroup size="sm" className="mb-3">
      <InputGroup.Text id="inputGroup-sizing-sm" style={{ color: "#214382" }}>
        {label}{" "}
        {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      </InputGroup.Text>
      <Form.Control
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        defaultValue={defaultValue}
        disabled={disabled}
        style={{
          backgroundColor: colored ? "#C2FFC7" : "",
        }}
      />
    </InputGroup>
  );
};

export default VerBusinessDetails;
